import React, { useState } from "react";
import api from "services/api";
import { __ } from "services/Translator";

// One-click self-exclusion: preset time-outs (24h / 7d / 30d) and a permanent
// option, distinct from the date-range cool-off below. Consumes the RG engine
// endpoint POST /rg/self-exclusion (202 = confirm first, 200 = applied). On
// success the caller logs the player out via onExcluded.
const PRESETS = [
  { key: "24h", label: "24 hours" },
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "permanent", label: "Permanent", danger: true },
];

export default function SelfExclusionPresets(props) {
  const [confirm, setConfirm] = useState(null); // { key, title, message }

  const start = async (key) => {
    if (props.setSpinner) props.setSpinner(true);
    var response = await api.post("/rg/self-exclusion", { preset_key: key });
    if (props.setSpinner) props.setSpinner(false);

    if (response.status === 202) {
      setConfirm({ key, ...response.data });
    } else if (response.status === 200) {
      finish(response);
    } else {
      props.showAlert(null, response.data && response.data.message, true);
    }
  };

  const apply = async () => {
    if (!confirm) return;
    if (props.setSpinner) props.setSpinner(true);
    var response = await api.post("/rg/self-exclusion", { preset_key: confirm.key, confirm: true });
    if (props.setSpinner) props.setSpinner(false);

    if (response.status === 200) {
      finish(response);
    } else {
      props.showAlert(null, response.data && response.data.message, true);
      setConfirm(null);
    }
  };

  const finish = (response) => {
    setConfirm(null);
    props.showAlert(__("Self-exclusion active"), response.data && response.data.message);
    if (props.onExcluded) {
      props.onExcluded();
    }
  };

  return (
    <div className="rg_self_excl">
      <h4 className="details__heading">{__("Take a break or self-exclude")}</h4>
      <p className="details__heading">
        <small>
          {__(
            "Lock yourself out instantly for a set period, or permanently. Once applied this cannot be undone until it expires."
          )}
        </small>
      </p>

      {!confirm ? (
        <div className="rg_self_excl_btns">
          {PRESETS.map((p) => (
            <button
              key={p.key}
              type="button"
              className={"rg_self_excl_btn" + (p.danger ? " danger" : "")}
              onClick={() => start(p.key)}
            >
              {__(p.label)}
            </button>
          ))}
        </div>
      ) : (
        <div className="rg_self_excl_confirm">
          <p className="details__heading">
            <b>{confirm.title}</b>
            <br />
            <small>{confirm.message}</small>
          </p>
          <div className="rg_self_excl_btns">
            <button type="button" className="commonBtn borderBtn" onClick={() => setConfirm(null)}>
              {__("Cancel")}
            </button>
            <button type="button" className="commonBtn pTwoBtn" onClick={apply}>
              {__("Confirm")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
